export { completeSlide } from "#complete-slide";
export { restoreSlideCompletion } from "#restore-slide-completion";
